import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import type { FilterOption, SelectFilterField } from '@/components/common/AdvancedFilter';
import { useDebounce } from '@/hooks/useDebounce';
import { getPersonOptionDetail } from '@/utils/personOption';
import { collectorsQueryOptions } from '../api/question.api';
import type { Collector } from '../types/question.types';

function toCollectorOptions(collectors: Collector[] | undefined): FilterOption[] {
  return (collectors ?? []).map((collector) => ({
    value: String(collector.userId),
    label: collector.fullName ?? collector.username ?? `#${collector.userId}`,
    description: getPersonOptionDetail(collector),
  }));
}

export function useCollectorFilterField(selectedId: string, boardId?: number): SelectFilterField {
  const [query, setQuery] = useState('');
  const searchText = useDebounce(query.trim());

  const { data, isFetching } = useQuery(collectorsQueryOptions(searchText, boardId));

  const results = toCollectorOptions(data);
  const isSelectedInResults =
    selectedId === '' || results.some((option) => option.value === selectedId);
  const options = isSelectedInResults
    ? results
    : [{ value: selectedId, label: `ZM #${selectedId}` }, ...results];

  return {
    key: 'userId',
    label: 'ZM Name',
    type: 'select',
    placeholder: 'All ZMs',
    options,
    onSearchChange: setQuery,
    isSearching: isFetching,
  };
}
